import { render, staticRenderFns } from "./UserDeletedMoreDropdown.vue?vue&type=template&id=e72d896c&scoped=true"
import script from "./UserDeletedMoreDropdown.vue?vue&type=script&lang=js"
export * from "./UserDeletedMoreDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72d896c",
  null
  
)

export default component.exports